// extracted by mini-css-extract-plugin
export default {"container":"PageSkeleton_container__rSZKH","table":"PageSkeleton_table__9jKjj","delete":"PageSkeleton_delete__uASzC","action":"PageSkeleton_action__wtZLe"};